export default "__VITE_ASSET__CD$yn0mH__"